import {createLazyFileRoute} from '@tanstack/react-router'

import Profile from '@/views/Account/Profile/Profile'

export const Route = createLazyFileRoute('/_account/profile/')({
  component: Profile,
})
